module.exports = __webpack_public_path__ + "static/media/home_play_button.751d70e2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_play_button.svg
// module id = 111
// module chunks = 0